// Number formatting — IdleVoid's suffix ladder (src/ui/format.ts) plus the
// small-number and rate forms a mining game needs.

const SUFFIXES = ['', 'K', 'M', 'B', 'T', 'Qa', 'Qi', 'Sx', 'Sp', 'Oc', 'No', 'Dc'];

export function fmtNum(n: number): string {
  if (!Number.isFinite(n)) return '∞';
  if (n < 0) return `-${fmtNum(-n)}`;
  if (n < 1000) return Math.floor(n).toString();
  let v = n;
  let tier = 0;
  while (v >= 1000 && tier < SUFFIXES.length - 1) { v /= 1000; tier++; }
  if (v >= 1000) return n.toExponential(2);
  return `${v.toFixed(1)}${SUFFIXES[tier]}`;
}

/** Like fmtNum, but keeps one or two decimals below 100 — for rates and small stocks. */
export function fmtFine(n: number): string {
  if (!Number.isFinite(n)) return '∞';
  if (Math.abs(n) >= 100) return fmtNum(n);
  if (Math.abs(n) >= 10) return n.toFixed(1);
  return n.toFixed(2);
}

export function fmtPct(fraction: number, digits = 0): string {
  return `${(fraction * 100).toFixed(digits)}%`;
}

export function fmtSigned(fraction: number): string {
  const pct = Math.round(fraction * 1000) / 10;
  return `${pct >= 0 ? '+' : ''}${pct}%`;
}

export function fmtTime(seconds: number): string {
  const s = Math.max(0, Math.round(seconds));
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60}s`;
  const h = Math.floor(m / 60);
  return `${h}h ${m % 60}m`;
}

export type Currency = 'gc' | 'te' | 'sc' | 'vs';

export const CUR_GLYPH: Readonly<Record<Currency, string>> = {
  gc: '◈',
  te: '◇',
  sc: '★',
  vs: '✦',
};

export function cur(c: Currency): string {
  return `<span class="cur ${c}">${CUR_GLYPH[c]}</span>`;
}

export function price(c: Currency, amount: number): string {
  return `${cur(c)} ${fmtNum(amount)}`;
}

export function esc(text: string): string {
  return text.replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]!));
}
